/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import {colors} from "nxtconstants";
import styled from "styled-components";

const Search = ({
  handleFaqSearch,
  totalResults
}) => {
  return (
    <SearchWrapper>
      <SearchInput
        placeholder="Search Faqs..."
        type="text"
        onChange={(e) => handleFaqSearch(e.target.value)}
      />
      <Count>
        ({totalResults})
      </Count>
    </SearchWrapper>
  );
};

const SearchWrapper = styled.div`
  margin: 1rem;
  background-color: #fff;
  padding: 0.5rem;
  border-radius: 0.3rem;
  position: sticky;
  top: 1rem;
  box-shadow: 0 0 12px #6725f42e;
  display: flex;
`;

const Count = styled.span`
  color: ${colors.gray};
`;

const SearchInput = styled.input`
  background-color: transparent;
  border: 0;
  outline: 0;
  font-size: 1rem;
  width: 100%;
`;

export default Search;
